module.exports = __webpack_public_path__ + "static/media/pantry_tablet.d6a28c36.jpg";